import { useCallback, useState } from 'react';
import { ChatResponseFile } from '../../Chat/types';

interface ImagePreviewState {
  file: ChatResponseFile;
  url: string;
}

export const useImagePreview = () => {
  const [imagePreview, setImagePreview] = useState<ImagePreviewState | null>(null);

  const openImagePreview = useCallback((file: ChatResponseFile, url: string) => {
    setImagePreview({ file, url });
  }, []);

  const closeImagePreview = useCallback(() => {
    setImagePreview(null);
  }, []);

  return { imagePreview, openImagePreview, closeImagePreview };
};
